import './ProgressBar.css';

export const ProgressBar = ({ isGenerating, currentStage = null }) => {
  const stages = [
    { id: 'noise_removal', name: 'Noise Removal', percentage: 15 },
    { id: 'transcribing', name: 'Transcribing Audio', percentage: 40 },
    { id: 'pii_redaction', name: 'Redacting PII', percentage: 60 },
    { id: 'soap_generation', name: 'Generating SOAP Note', percentage: 85 },
    { id: 'ai_analysis', name: 'AI Clinical Analysis', percentage: 100 }
  ];

  // Determine progress based on current stage
  const getProgressForStage = () => {
    if (!currentStage) return 5; // Default if no stage provided

    const stageIndex = stages.findIndex(s => s.id === currentStage);
    if (stageIndex === -1) return 5;

    return stages[stageIndex].percentage;
  };

  const progress = getProgressForStage();
  const currentStageIndex = currentStage
    ? stages.findIndex(s => s.id === currentStage)
    : 0;

  if (!isGenerating) return null;


  return (
    <div className="progress-container">
      <div className="progress-header">
        <h3 className="progress-title">Processing Your SOAP Note</h3>
        <p className="progress-subtitle">Please wait while we process your audio</p>
      </div>

      {/* Main Progress Bar */}
      <div className="progress-bar-wrapper">
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }}></div>
          <div className="progress-shimmer"></div>
        </div>
        <div className="progress-percentage">{Math.round(progress)}%</div>
      </div>

      {/* Stage Indicators */}
      <div className="stage-indicators">
        {stages.map((stage, index) => (
          <div
            key={index}
            className={`stage-indicator ${index <= currentStageIndex ? 'active' : ''}`}
          >
            <div className={`stage-dot ${index <= currentStageIndex ? 'active' : ''}`}></div>
            <span className="stage-label">{stage.name}</span>
          </div>
        ))}
      </div>

      {/* Status Message */}
      <div className="progress-message">
        <svg className="progress-spinner" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" opacity="0.25"/>
          <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
        </svg>
        <span>{stages[currentStageIndex]?.name || 'Processing...'}</span>
      </div>
    </div>
  );
};
